export default "__VITE_ASSET__XW5lp3nm__"